import * as Constants from '../constants/';
import { lastXDays } from '../../common/utilities/dateRangeHelper';

const userDefaultRange = parseInt(
  localStorage.getItem('ecs.analytics.defaultRange'),
  10
);
let userRange;
// WARNING: this is linked to the AnalyticsFilter default on the <DateRange> component line #269
if ([1, 7, 30].includes(userDefaultRange)) {
  userRange = userDefaultRange;
} else {
  userRange = 1;
}

const initialState = {
  isLoading: false,
  jobsLoading: false,
  jobDetailsLoading: false,
  hasLoadedOnce: false,
  error: null,
  data: {
    filter: {
      ...lastXDays(userRange).dates
    },
    attributeFilters: {},
    attributeRadio: 'nrOfAssets',
    blocks: [],
    jobs: [],
    performance: {
      performers: [],
      details: [],
      summary: {}
    }
  }
};

function mergeJobDetails(jobs, jobId, details) {
  return jobs.map(job => {
    if (job.id === jobId) {
      return { ...job, ...details };
    } else {
      return { ...job };
    }
  });
}

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_JOBS:
      return { ...state, jobsLoading: true, hasLoadedOnce: true };
    case Constants.REQUEST_JOB_DETAILS:
      return { ...state, jobDetailsLoading: true, hasLoadedOnce: true };
    case Constants.REQUEST_PERFORMANCE:
      return { ...state, isLoading: true, hasLoadedOnce: true };
    case Constants.RECEIVE_JOBS:
      if (action.error) {
        return { ...state, jobsLoading: false, error: action.error };
      }
      return {
        ...state,
        jobsLoading: false,
        data: {
          ...state.data,
          ...action.data
        }
      };
    case Constants.RECEIVE_JOB_DETAILS:
      if (action.error) {
        return { ...state, jobDetailsLoading: false, error: action.error };
      }
      return {
        ...state,
        jobDetailsLoading: false,
        data: {
          ...state.data,
          jobs: mergeJobDetails(state.data.jobs, action.id, action.data)
        }
      };
    case Constants.MODIFY_ANALYTICS_FILTER:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          filter: { ...action.filter }
        }
      };
    case Constants.MODIFY_ATTRIBUTE_FILTERS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          attributeFilters: { ...action.attributeFilters }
        }
      };
    case Constants.MODIFY_ATTRIBUTE_CHART:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          attributeRadio: action.check
        }
      };
    case Constants.RECEIVE_PERFORMANCE:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          performance: {
            details: action.data?.details || [],
            performers: (action.data?.performers || []).filter(p => !!p),
            summary: action.data?.summary || {}
          }
        }
      };
    default:
      return state;
  }
}
